export default "__VITE_ASSET__NVaEVoIt__"